import { atom } from "recoil";

export const navbarState = atom({
  key: "navbarState",
  default: {},
});
